import { Component } from '@angular/core';

import { AnchorDirective, CurrencySymbolPipe } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { DepositService } from '../../../../service/deposit.service';
import { OptionListService } from '../../../../service/optionList.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-transaction-currency',
    templateUrl: 'transaction-currency.component.html',
    standalone: true,
    imports: [MessageComponent, TranslateModule, CurrencySymbolPipe, AnchorDirective],
})
export class TransactionCurrencyComponent {
    defaultCurrency: string;

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    constructor(
        private optionListService: OptionListService,
        private depositService: DepositService,
    ) {
        this.defaultCurrency = this.depositService?.depositInfo?.amountInfo?.nativeCurrency;
    }

    gotoAllOptions() {
        this.optionListService.redirectToMainCashier('&type=options');
    }
}
